import { render, staticRenderFns } from "./importQuote.vue?vue&type=template&id=1ff88610&scoped=true&"
import script from "./importQuote.vue?vue&type=script&lang=js&"
export * from "./importQuote.vue?vue&type=script&lang=js&"
import style0 from "./importQuote.vue?vue&type=style&index=0&id=1ff88610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff88610",
  null
  
)

export default component.exports